
/*
    Display for all current lane assignments as a list,
    with a small filter on top for selecting the location to view,
    and a button to export a report to excel
*/

import React, { useContext } from "react";

import MainContext from "../MainContext";
import DataContext from "../DataContext";

import SubNav from "../Components/SubNav";
import LocationDropDown from "../Components/LocationDropDown";
import VerticalLayout from "../Components/VerticalLayout";

import LaneAssignmentData from "../DataDisplay/LaneAssignmentData";

import { getLaneAssignents } from "../Requests/LaneRequests";

import ReportExport from "../Components/Excel/ReportExport";

//
// construction for allowing changes to the DataContext to properly trigger a data reload
//
const LaneAssignmentsPageContainer = (props) => {
    const context = useContext(DataContext);

    return (
        <LaneAssignmentsPage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default LaneAssignmentsPageContainer;

class LaneAssignmentsPage extends React.Component {

    static contextType = MainContext;

    state = {
        location: "",
        data: [],
        routeFilter: "",
        filteredData: [],
        message: ""
    }

    onLocationChange = (evt) => {
        this.setState({location: evt.target.value}, ()=> {
            this.getData();
        });
    }

    getData = () => {
        const request = () => getLaneAssignents(this.state.location);
        const then = ({data}) => {
            console.log("LANE CHANGE DATA", data);
            if(data && data.length){
                this.setState({data, filteredData: data, message: ""});
            }
            else{
                this.setState({data, filtereData: data, message: "No records for this location"});
            }
        };

        this.context.runProcessing(request, then, "getLaneAssignents");
    }

    componentDidUpdate() {
        // handle any potential reload
        if(this.props.dataReload){
            console.log("GET DATA!!!");
            this.props.setReload(false, () => {                
                this.getData();
            });
        }
    }

    routeFilterChange = (evt) => {
        this.setState({routeFilter: evt.target.value}, () => {
            this.runFilter();
        });
    }

    runFilter = () => {
        if(this.state.routeFilter){
            const copy = this.state.data.filter(d => {
                return d.lineNumber.indexOf(this.state.routeFilter) >= 0;
            });
            console.log("LANE FILTER COPY", copy);
            this.setState({filteredData: copy});
        }
        else{
            this.setState({filteredData: this.state.data});
        }
    }

    render() {
        return (
            <VerticalLayout firstHeight={8}>
                <SubNav>
                    <div className="form-element-horizontal">
                        <label style={{justifySelf: "flex-end"}}>Location</label>
                        <LocationDropDown setFocus={true} selected={this.state.location} updateValue={this.onLocationChange} />
                    </div>
                    <ReportExport filename={`Lane Assignments ${this.state.location} ${new Date()}`} data={[{name: `Lane Assignments - ${this.state.location}`, records: this.state.data}]} />
                    {
                        this.state.location
                        ? <div className="form-element-horizontal">
                            <label style={{justifySelf: "flex-end"}}>Route</label>
                            <input type="text" value={this.state.routeFilter} onChange={this.routeFilterChange} />
                        </div>
                        : null
                    }
                </SubNav>
                <div className="content">
                    {
                        this.state.message !== ""
                        ? <div className="message">
                            {this.state.message}
                        </div>
                        : null
                    }
                    {
                        this.state.filteredData.map((row, index) => {
                            return <LaneAssignmentData key={index} data={row} />
                        })
                    }
                </div>
            </VerticalLayout>
        )
    }
}
